import { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button, Card, Grid, Item } from 'semantic-ui-react';
import { Link } from 'react-router-dom';
import Icon from '@plone/volto/components/theme/Icon/Icon';
import { getProducts } from '../../../actions';
import { MixedTitle } from '../../.';

import chunk from 'lodash/chunk';
import map from 'lodash/map';

import missingIMG from '../../../static/missing.jpg';
import arrowSVG from '../../../icons/arrow.svg';

const View = (props) => {
  const { id, data, isEditMode } = props;
  const dispatch = useDispatch();
  const [showAll, setShowAll] = useState(Boolean(isEditMode));
  const items = showAll ? data.products : props.data.products?.slice(0, 8);
  const products = useSelector(
    (state) => state.products?.subrequests?.[id]?.data,
  );

  useEffect(() => {
    dispatch(getProducts(items, id));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [showAll, data.products]);

  let itemPairs = chunk(products, 2);

  return (
    <div className="block tile passende-produkte">
      <div className="passende-produkte-listing">
        <h2>Passende Produkte</h2>
        <Grid columns={2} stackable={true}>
          {map(itemPairs, (itemPair) => (
            <Grid.Row>
              {map(itemPair, (item) => (
                <Grid.Column>
                  <Item.Group unstackable={true}>
                    <Item>
                      <Item.Image
                        src={
                          (item.image &&
                            `${item.image['@id']}/@@images/image/mini`) ||
                          missingIMG
                        }
                        alt={item.name}
                      />
                      <Item.Content>
                        <Item.Header>
                          {isEditMode ? (
                            <>
                              <b>{item.display_rezeptcode}</b> {item.name}
                            </>
                          ) : (
                            <Link to={`/alle-produkte/${item.id}`}>
                              <b>{item.display_rezeptcode}</b> {item.name}
                            </Link>
                          )}
                        </Item.Header>
                      </Item.Content>
                    </Item>
                  </Item.Group>
                </Grid.Column>
              ))}
            </Grid.Row>
          ))}
        </Grid>
        {data.products?.length > 8 && showAll === false && (
          <Grid>
            <Grid.Row>
              <Grid.Column stretched={true}>
                <Card.Group stackable centered itemsPerRow={2}>
                  <Card
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      height: '155px',
                    }}
                  >
                    <Button
                      className="small brandButtonSecondary"
                      onClick={() => setShowAll(!showAll)}
                    >
                      <MixedTitle reverse>alle Produkte anzeigen</MixedTitle>
                      <Icon name={arrowSVG} size="17px" className="right" />
                    </Button>
                  </Card>
                </Card.Group>
              </Grid.Column>
            </Grid.Row>
          </Grid>
        )}
      </div>
    </div>
  );
};

export default View;
